<script setup lang="ts">
import HorizontalCarousel from '@/components/HorizontalCarousel.vue';
import EventBlock, { type Props as EventProps } from './EventBlock.vue';

const props = withDefaults(
    defineProps<{
        events: EventProps[];
        gap?: number;
        align?: 'start' | 'center' | 'end' | 'stretch';
        minWidth?: number;
        showArrows?: boolean;
        forceMode?: 'row' | 'carousel' | null;
    }>(),
    {
        gap: 12,
        align: 'center',
        minWidth: 280,
        showArrows: true,
        forceMode: null,
    }
);
</script>

<template>
    <HorizontalCarousel
        :items="events"
        :gap="gap"
        :align="align"
        :minWidth="minWidth"
        :showArrows="showArrows"
        :forceMode="forceMode"
    >
        <template #item="{ item }">
            <EventBlock class="w-full" v-bind="item as EventProps" />
        </template>
    </HorizontalCarousel>
</template>
